export default {"src":"/_next/static/media/shot_tracked_full.444ae159.gif","height":646,"width":1148,"blurWidth":0,"blurHeight":0};